import { gql } from 'graphql-tag';

import { AT_IMAGE_FRAGMENT, OR_VIDEO_FRAGMENT } from 'src/graphql/fragments/fragments';
import { GetInstructorLedTrainingQuery } from 'src/graphql/generated/GetInstructorLedTraining';

export const GET_INSTRUCTOR_LED_TRAINING = gql`
  ${AT_IMAGE_FRAGMENT}
  ${OR_VIDEO_FRAGMENT}
  query getInstructorLedTraining($slug: String!, $preview: Boolean!) {
    instructorLedTrainingCollection(preview: $preview, limit: 1, where: { slug: $slug }) {
      items {
        __typename
        sys {
          id
        }
        courseTitleExternal
        duration
        description {
          json
          links {
            assets {
              hyperlink {
                sys {
                  id
                }
                title
                description
                fileName
                url
              }
            }
            entries {
              block {
                __typename
                sys {
                  id
                }
                ... on AtImage {
                  ...AtImageFragment
                }
                ... on OrVideo {
                  ...OrVideoFragment
                }
              }
              inline {
                __typename
                sys {
                  id
                }
                ... on AtImage {
                  ...AtImageFragment
                }
              }
            }
          }
        }
        instructor {
          sys {
            id
          }
          nameInternal
          image {
            ...AtImageFragment
          }
          imageAlt
          bio
          contactEmail
          locationValue
        }
      }
    }
  }
`;

export type ContentfulInstructorLedTrainingResponse = GetInstructorLedTrainingQuery;
export type ContentfulInstructorLedTraining =
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0];
export type ContentfulInstructorLedTrainingDescription =
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0]['description'];
export type ContentfulInstructor =
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0]['instructor'];
